import { Box, Typography } from '@mui/material'
import { IconFileText } from '@tabler/icons-react'

import Row from 'src/components/Row/Row'

const ThreadPageButton = ({ page, onClick }) => {
  return (
    <Row
      onClick={(e) => {
        e.stopPropagation()
        onClick({ page })
      }}
      sx={{
        color: 'text.secondary',
        borderRadius: '8px',
        cursor: 'pointer',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        maxWidth: '400px',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        '&:hover': { color: 'text.primary' },
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '52px',
          width: '52px',
          overflow: 'hidden',
          backgroundColor: (theme) => theme.palette.divider,
          flexShrink: 0,
          '& .tabler-icon': {
            color: (theme) => theme.palette.action.disabled,
          },
        }}
      >
        <IconFileText
          size={26}
          stroke={1.3}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          ml: '12px',
          width: 'calc(100% - 56px - 24px)',
          maxWidth: '400px',
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '14px',
            letterSpacing: '-0.3px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            opacity: 0.8,
          }}
        >
          {page.title}
        </Typography>
        <Typography
          sx={{
            fontSize: '11px',
            letterSpacing: '-0.3px',
            opacity: 0.5,
          }}
        >
          Click to open page
        </Typography>
      </Box>
    </Row>
  )
}

export default ThreadPageButton
